<template>
  <div>
    <strong v-if="employeeState=='showing'">
      <p class="text-danger" v-if="edited">
        Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a>
      </p>
    </strong>
    <b-button class="float-right" @click="resetNewSchedule" v-if="edited == true" >Descartar cambios</b-button>

    <div class="mb-3">
      <b-button v-if="editingState == 'updating' && can('update', 'employee_schedule')" @click="isStacked = !isStacked">
        {{ isStacked ? 'Ver en forma de tabla' : 'Ver en forma de lista' }}
      </b-button>
    </div>
    
    <b-table v-if="schedules.length>0" :fields="scheduleFields" :items="schedules" :stacked="editingState == 'updating' && can('update', 'employee_schedule') && isStacked" responsive hover striped>
      <template #cell(effective_date)="data">
        <b-form-input type="date" 
          :value="data.item.effective_date" 
          @input="updateScheduleDate($event, data.item.pivot)"
          v-if="editingState == 'updating' && can('update', 'employee_schedule')"
          >
        </b-form-input>
        <span v-if="editingState != 'updating' || !can('update', 'employee_schedule')">
          {{ data.item.effective_date }}
        </span>
      </template>
      <template #cell(actions)="data">
        <b-button size="sm" :variant="data.item.deleted ? 'secondary' : 'danger'" v-if="editingState =='updating' && can('delete', 'employee_schedule')" @click="deleteSchedule(data.item.pivot)">
          {{ data.item.deleted ? 'No eliminar' : 'Eliminar' }}
        </b-button>
      </template>
    </b-table>
    <b-button variant="link" v-if="state=='show'&&can('create', 'employee_schedule')&&!deleted" @click="create">Agregar horario</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Horario">  
        <b-form-select v-model="selectedSchedule" :options="scheduleOptions"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="A partir del">  
        <b-form-input v-model="effectiveDate" type="date"></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  data (){
    return {
      selectedSchedule: null,
      effectiveDate: '',
      scheduleFields: [
        {
          key: 'name',
          label: 'Horario'
        },
        {
          key: 'effective_date',
          label: 'A partir del',
          sortable: true
        },
        {
          key: 'actions',
          label: ' '
        }
      ],
      isStacked: false,
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },

    ...mapActions(['resetNewSchedule', 'saveChanges']),
    ...mapMutations({
      updateSchedule: 'updateNewScheduleAttribute',
      create: 'creatingSchedule',
      updateEmployeeSchedule: 'updateEmployeeSchedule',
      deleteEmployeeSchedule: 'deleteEmployeeSchedule',
    }),
    addIfValid (){
      var validation = this.valid()

      if(validation.valid){
        let schedule = this.allSchedules.find(s => s.id === this.selectedSchedule);

        this.$store.dispatch('addSchedule', {
          id: this.selectedSchedule,
          name: schedule.name,
          effective_date: this.effectiveDate,
          pivot: null
        });
        this.selectedSchedule = null
        this.effectiveDate = null
      }
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.selectedSchedule!==null, 'Debes escoger un horario')
      validator.rule(
        this.effectiveDate!='', 'Debes de escoger una fecha a partir de la cuál el empleado tiene el horario')
      return validator.validate()
    },
    updateScheduleDate(date, pivot) {
      this.updateEmployeeSchedule({date, pivot});
    },
    deleteSchedule(schedule) {
      this.deleteEmployeeSchedule(schedule);
    }
  },
  computed: {
    ...mapGetters({
      edited: 'scheduleEdited',
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      schedules: state=>state.employeeManager.employee.schedules,
      allSchedules: state => state.employeeManager.schedules,
      state: state=>state.employeeManager.scheduleState,
      editingState: state => state.employeeManager.state,
      deleted_at: state=>state.employeeManager.employee.deleted_at,
    }),
    scheduleOptions() {
      return this.allSchedules.map(s => {
        return {
          value: s.id,
          text: s.name
        }
      })
    },
    deleted() {
      return this.deleted_at !== null;
    }
  }
  
}
</script>

